// extracted by mini-css-extract-plugin
export default {"page":"hospitalSearch_page__Rl-l0"};